import React from 'react';
import PropTypes from 'prop-types';
import './nav.css';

function Nav(props) {
  const logged_out_nav = (
    <div>
      {props.displayed_form === 'signup'
        ? <div className="title-or" onClick={() => props.display_form('login')}>or sign in to your account</div>
        : <div className="title-or" onClick={() => props.display_form('signup')}>or create an account</div>
      }
      </div>
  );

  const logged_in_nav = (
    <div>
      <div className="title-or" onClick={props.handle_logout}>Click here to log out</div>
    </div>
  );
  return <div>{props.logged_in ? logged_in_nav : logged_out_nav}</div>;
}

export default Nav;

Nav.propTypes = {
  logged_in: PropTypes.bool.isRequired,
  display_form: PropTypes.func.isRequired,
  handle_logout: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Nav.js